import React from 'react';

const BookPromo = () => (
  <div className="container">
    <div className="row d-flex justify-content-between align-items-lg-center flex-wrap g-mt-minus-50--lg">
      <div className="col-md-6 order-md-6">
        <div className="g-brd-around--md rounded">
          <img
            className="img-fluid w-100 rounded"
            src="/images/05.png"
            alt="Are You Ready? book cover"
          />
        </div>
      </div>

      <div className="col-md-6 col-lg-4 ml-auto order-md-1">
        <div className="g-mt-minus-30 g-mt-0--md g-ml-minus-100--lg">
          <div className="g-mb-20">
            <h2 className="g-color-black g-font-weight-600 g-font-size-25 g-font-size-35--lg g-line-height-1_2 mb-4">
              Are You Ready?
            </h2>

            <p className="g-font-size-16">
              <strong>Are You Ready?</strong> is a timely and insightful work by Bishop
              K. J. Brown that speaks to the heart of every believer.
            </p>

            <p className="g-font-size-14">
              In the Christian community, predicting the exact timing, order, and scope
              of end-time events has often been a source of controversy and debate.
              There are varying views on what is called &quot;the Second Coming&quot; and
              &quot;the Rapture.&quot; In addition, there is much discussion about whether
              the Rapture and the Second Coming are two separate events or one event
              with two phases.
            </p>

            <p className="g-font-size-14">
              This written work is designed to break down end-time preparation,
              positions, and promises so that believers are informed rather than
              fearful. Bishop K. J. Brown lays out a simple, easy-to-understand
              argument, using practical biblical support, to empower the reader to move
              forward in confidence rather than confusion concerning the return of
              Christ for His bride, the Church. All Christians agree that Christ will
              return.
            </p>

            <p className="g-font-size-14">
              The question is: <strong>&quot;Are you ready?&quot;</strong>
            </p>

            <p className="g-font-size-14 g-mb-10">
              <strong>Paperback:</strong> $19.99
            </p>

            <form
              action="https://www.paypal.com/cgi-bin/webscr"
              method="post"
              target="_top"
            >
              <input type="hidden" name="cmd" value="_s-xclick" />
              <input type="hidden" name="hosted_button_id" value="V4VMB6KLW9TGJ" />
              <input
                type="image"
                src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif"
                border="0"
                name="submit"
                alt="PayPal - The safer, easier way to pay online!"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BookPromo;
